import { render, staticRenderFns } from "./HotTopic.vue?vue&type=template&id=5f94163f&scoped=true"
import script from "./HotTopic.vue?vue&type=script&lang=js"
export * from "./HotTopic.vue?vue&type=script&lang=js"
import style0 from "./HotTopic.vue?vue&type=style&index=0&id=5f94163f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f94163f",
  null
  
)

export default component.exports